const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const buildHeaders = (token, withBody = false) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-api-key": X_API_KEY,
  };
  if (withBody) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
};

export const listAnnouncements = async token => {
  if (!token) {
    return { count: 0, unread_count: 0, results: [] };
  }

  const response = await fetch(`${API_URL}announcements/`, {
    method: "GET",
    mode: "cors",
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error("Failed to load announcements");
  }

  return response.json();
};

export const markAnnouncementRead = async (token, announcementId) => {
  if (!token || !announcementId) return;

  const response = await fetch(`${API_URL}announcements/${announcementId}/read/`, {
    method: "POST",
    mode: "cors",
    headers: buildHeaders(token, true),
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Failed to mark announcement as read (${response.status})`);
  }
};

export const dismissAnnouncement = async (token, announcementId) => {
  if (!token || !announcementId) return;

  const response = await fetch(`${API_URL}announcements/${announcementId}/dismiss/`, {
    method: "POST",
    mode: "cors",
    headers: buildHeaders(token, true),
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`Failed to dismiss announcement (${response.status})`);
  }
};
